export enum NewsDivision {
  CCL = 'ccl',
  TSF = 'tsf',
  Company = 'company',
}

export interface News {
  id: string;
  title: string;
  htmlContent: string;
  createdAt: number;
  updatedAt?: number;
  /** Calendar date shown on dashboard / list (YYYY-MM-DD). */
  displayDate: string;
  order?: number;
  division: NewsDivision;
}
